<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <div>
          <app-row icon="book" title="رشته:" :value="item.Reshte" />
          <app-row icon="book" title="نوع درخواست" :value="item.StrKRequest" />
        </div>
        <div v-if="selected">
          <app-row
            icon="calendar-alt"
            title="تاریخ درخواست:"
            :value="item.DDate"
          />
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضیحات طلبه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="item.StudentComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasStudentFile"
                  @click="$emit('callDownload', item.Fserial, item.HashToken)"
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="d-flex">
                <b>بررسی شرایط اولیه صدور مجوز تدریس:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.Amoozesh1State }}.
                {{ item.Amoozesh1Comment }}
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="d-flex">
                <b>اطلاعات مربوط به ارزیابی:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                <div class="indent" v-if="item.KRequest == 'False'">
                  تاریخ مصاحبه: {{ item.DAzmoon }}
                  <br />
                  زمان مصاحبه: {{ item.TAzmoon }}
                  <br />
                  مکان مصاحبه: {{ item.LAzmoon }}
                </div>
              </v-col>
            </v-row>
            <template template v-if="item.KRequest == 'True'">
              <v-row align="center">
                <v-col class="d-flex">
                  <b>مشاهده نتایج ارزیابی:</b>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col class="d-flex content">
                  <div class="indent">
                    <template v-if="item.Form1Serial != '0'">
                      <a @click="$emit('showArzyabi', item.Form1Serial)">
                        نتایج ارزیابی اول</a
                      >
                      {{ item.Emtiaz1 }}
                    </template>
                    <template v-if="item.Form2Serial != '0'">
                      <br />
                      <a @click="$emit('showArzyabi', item.Form1Serial)">
                        نتایج ارزیابی دوم</a
                      >
                      {{ item.Emtiaz2 }}
                    </template>
                    <template v-if="item.Form3Serial != '0'">
                      <br />
                      <a @click="$emit('showArzyabi', item.Form1Serial)">
                        نتایج ارزیابی سوم</a
                      >
                      {{ item.Emtiaz3 }}
                    </template>
                  </div>
                </v-col>
              </v-row>
            </template>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نتیجه ارزیابی:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.Amoozesh2State }}. {{ item.Amoozesh2Comment }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر واحد حراست:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.TahghighatState }}. {{ item.TahghighatComment }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر نهایی:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.Amoozesh3State }}. {{ item.Amoozesh3Comment }}
              </v-col>
            </v-row>

            <v-row v-if="item.Removeable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.Fserial)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
            <div style="padding: 5px"></div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
